var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIncludeFiltered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 16V10.6667H8.88889V12.4444H16V14.2222H8.88889V16H7.11111ZM0 14.2222V12.4444H5.33333V14.2222H0ZM3.55556 10.6667V8.88889H0V7.11111H3.55556V5.33333H5.33333V10.6667H3.55556ZM7.11111 8.88889V7.11111H16V8.88889H7.11111ZM10.6667 5.33333V0H12.4444V1.77778H16V3.55556H12.4444V5.33333H10.6667ZM0 3.55556V1.77778H8.88889V3.55556H0Z",
    fill: "#5E6974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIncludeFiltered);
export default __webpack_public_path__ + "static/media/export-include-filtered.69020ad3c00b67e48b42f1b1b5686211.svg";
export { ForwardRef as ReactComponent };